import React from 'react';
import NavigationBar from '../components/header/NavigationBar';
import { Box } from '@mui/material';
import { SX_STYLES } from '../styles/pages/LandingPageStyles';
import Dashboard from './Dashboard';
import ProductDetails from './products/ProductDetails';
import { ROUTES } from '../constants/Routes';
import Products from './products/Products';
import Services from './services/Services';
import InstalledProjects from './projects/InstalledProjects';
import AboutUs from './AboutUs';
import { Routes, Route, useLocation } from "react-router-dom";
import FooterSocialLinks from '../components/footer/FooterSocialLinks';
import { AnimatePresence } from 'framer-motion';
import PageTransition from '../components/general/PageTransition';
import BackToTop from '../components/general/BackToTop';
import PageTitle from '../components/general/PageTitle';

const LandingPage = (props) => {
    const location = useLocation();
    return (
        <Box sx={SX_STYLES.contentContainer}>
            <PageTitle/>
            <NavigationBar/>
            <AnimatePresence mode='wait'>
                <Routes location={location} key={location.pathname}>
                    <Route path='/' element={<PageTransition><Dashboard/></PageTransition>}/>
                    <Route path={ROUTES.PRODUCTS} element={<PageTransition><Products/></PageTransition>}/>
                    <Route path={ROUTES.PRODUCT_DETAILS} element={<PageTransition><ProductDetails/></PageTransition>}/>
                    <Route path={ROUTES.PRODUCTS+'/'+ROUTES.PRODUCT_DETAILS} element={<PageTransition><ProductDetails/></PageTransition>}/>
                    <Route path={ROUTES.SERVICES} element={<PageTransition><Services/></PageTransition>}/>
                    <Route path={ROUTES.SERVICES+'/'+ROUTES.PRODUCT_DETAILS} element={<PageTransition><ProductDetails/></PageTransition>}/>
                    <Route path={ROUTES.ABOUT_US} element={<PageTransition><AboutUs/></PageTransition>}/>
                    <Route path={ROUTES.INSTALLED_PROJECTS} element={<PageTransition><InstalledProjects/></PageTransition>}/>
                    <Route path={ROUTES.INSTALLED_PROJECTS+'/'+ROUTES.PRODUCT_DETAILS} element={<PageTransition><ProductDetails/></PageTransition>}/>
                </Routes>
            </AnimatePresence>
            <FooterSocialLinks/>
            <BackToTop/>
        </Box>
    );
}

export default LandingPage;